import { render } from "./bindChannelAccount.vue?vue&type=template&id=c414b426"
import script from "./bindChannelAccount.vue?vue&type=script&lang=js"
export * from "./bindChannelAccount.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/channel/bindChannelAccount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c414b426"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c414b426', __exports__)) {
    console.log('reload')
    api.reload('c414b426', __exports__)
  }
  
  module.hot.accept("./bindChannelAccount.vue?vue&type=template&id=c414b426", () => {
    console.log('re-render')
    api.rerender('c414b426', render)
  })

}


export default __exports__